const checkIfDifferentVariants = () => {
  const itemsVariantIds = document.getElementsByClassName('item-variant-id');
  const itemsVariantIdsArray = Array.from(itemsVariantIds);
  const checkedItems = itemsVariantIdsArray.reduce(
    (acc, curr) => {
      const sameVariants = acc.checkedItems.filter((item, index) => item === curr.value);

      if (sameVariants.length > 0) {
        acc.allDifferent = false;
      }
      acc.checkedItems.push(curr.value);
      return acc;
    },
    { checkedItems: [], allDifferent: true },
  );
  const submitButton = document.getElementsByClassName('combo-submit-button')[0];

  const errorMessage = document.getElementById('error-message-variants');
  if (checkedItems.allDifferent) {
    submitButton.removeAttribute('disabled');
    errorMessage.classList.add('ec-hidden');
  } else {
    submitButton.setAttribute('disabled', true);
    errorMessage.classList.remove('ec-hidden');
  }
};

checkIfAllVariantsAvailable = () => {
  const itemsVariantIds = document.getElementsByClassName('item-variant-id');
  const itemsVariantIdsArray = Array.from(itemsVariantIds);
  const allAvailable = itemsVariantIdsArray.reduce((acc, curr) => {
    const variant = products.reduce((acc2, curr2) => {
      const product = curr2.variants.find((variant) => variant.id === parseInt(curr.value));
      if (product) {
        return curr2.variants.find((variant) => variant.id === parseInt(curr.value));
      } else {
        return acc2;
      }
    }, null);
    if (!variant.available) {
      return false;
    }
    return acc;
  }, true);
  const submitButton = document.getElementsByClassName('combo-submit-button')[0];

  const errorMessage = document.getElementById('error-message-variants');
  if (allAvailable) {
    submitButton.removeAttribute('disabled');
    errorMessage.classList.add('ec-hidden');
  } else {
    submitButton.setAttribute('disabled', true);
    errorMessage.classList.remove('ec-hidden');
  }
};

const hideSoldoutColor = (variant, product, label) => {
  const color = product.variants.find((v) => v.id === parseInt(variant)).options[0];
  const variantsWithColor = product.variants.filter((v) => v.options[0] === color);
  const soldout = variantsWithColor.every((v) => v.inventory_quantity === 0);
  if (soldout) {
    label.classList.add('ec-hidden');
  }
};

const roundToNearestFiveCents = (number) => {
  return parseFloat((Math.round(number / 0.05) * 0.05).toFixed(2)).toFixed(2);
};

const calculateBundlePrice = () => {
  const discount = bundleTags.find((tag) => tag.includes('combo_discount'));
  const discountValue = parseInt(discount.split('_')[2]);
  const itemsVariantIds = document.getElementsByClassName('item-variant-id');
  const itemsVariantIdsArray = Array.from(itemsVariantIds);
  const itemsVariantIdsValues = itemsVariantIdsArray.map((item) => item.value);
  const priceTotal = itemsVariantIdsValues.reduce((acc, currVariant) => {
    const variantPrice = products.reduce((acc, currProduct) => {
      const variant = currProduct.variants.find((variant) => {
        return variant.id === parseInt(currVariant);
      });
      if (variant) {
        return acc + variant.price;
      }
      return acc;
    }, 0);
    if (variantPrice) {
      return acc + variantPrice;
    }
    return acc;
  }, 0);
  const priceTotalReduced = priceTotal * ((100 - parseInt(discountValue)) / 100);
  const priceTotalReducedParsed = parseFloat(priceTotalReduced / 100).toFixed(2);

  // const priceRounded = roundToNearestFiveCents(priceTotalReducedParsed);
  // console.log('priceRounded', priceRounded);

  const elementReduced = document.getElementById('combo-reduced-price');
  const elementRegular = document.getElementById('combo-regular-price');
  let finalAdjustment = priceTotalReducedParsed;
  if (!finalAdjustment.endsWith(".00")){
    finalAdjustment = Math.floor(finalAdjustment) + 0.90;
  }
  elementReduced.innerHTML = `${getCurrency()}${finalAdjustment}`;
  elementRegular.innerHTML = `${getCurrency()}${parseFloat(priceTotal / 100).toFixed(2)}`;
};

const changeImage = (image, variant) => {
  if (variant.featured_image) {
    image.src = variant.featured_image.src;
    image.alt = variant.featured_image.alt;
    image.title = variant.featured_image.alt;
  }
};

const getClickedInputForm = (target, inputForms) => {
  let clickedLabel;
  if (target.localName === 'span') {
    clickedLabel = target.parentNode;
  } else {
    clickedLabel = target;
  }
  const clickedInputFormIndex = inputForms.findIndex((inputForm) => inputForm.contains(clickedLabel));
  return { index: clickedInputFormIndex, variantId: clickedLabel.dataset.variantId, comboIndex: clickedLabel.dataset.index };
};

const rebuildInputs = (currentVariant, inputForms, clickedInputForm, product) => {
  const currentVariable = currentVariant.options[clickedInputForm.index];
  const newVariants = product.variants.filter((variant) => variant.options[clickedInputForm.index] === currentVariable);

  inputForms.forEach((inputForm, index) => {
    const inputs = Array.from(inputForm.getElementsByClassName('product-form__radio'));
    const labels = Array.from(inputForm.getElementsByClassName('product-form__label'));
    if (index === clickedInputForm.index) {
      inputs.forEach((input) => {
        if (input.getAttribute('data-variant-id') == currentVariant.id) {
          input.setAttribute('checked', true);
        } else {
          input.removeAttribute('checked');
        }
      });
    }
    let isMetafield = document.getElementById(`metafield-checkbox-${clickedInputForm.comboIndex}`).getAttribute('is-metafield');
    if (isMetafield != 'true') {
      if (index !== clickedInputForm.index) {
        inputs.forEach((input) => {
          if (!input.getAttribute('name').includes('Color')) {
            const newVariant = newVariants.find((variant) => variant.options[index] === input.value);
            const labelToEdit = labels.find((label) => label.dataset.variantId === input.dataset.variantId);
            labelToEdit.dataset.variantId = newVariant.id;
            labelToEdit.classList.remove('available');
            labelToEdit.classList.remove('soldout');
            if (newVariant.available) {
              labelToEdit.classList.add('available');
            } else {
              labelToEdit.classList.add('soldout');
            }
            input.dataset.variantId = newVariant.id;
          }
          if (input.getAttribute('name').includes('Color')) {
            const newVariant = newVariants.find(
              (variant) =>
                variant.options[index] === input.value && variant.options[clickedInputForm.index] === currentVariable,
            );
            if (newVariant) {
              const labelToEdit = labels.find((label) => label.dataset.variantId === input.dataset.variantId);
              labelToEdit.dataset.variantId = newVariant.id;
              input.dataset.variantId = newVariant.id;
            }
          }
        });
      }
    }
  });
};

const checkInputs = (item, currentVariant, product, image, comboItemIndex) => {
  const inputForms = Array.from(item.getElementsByClassName('product-form__input'));
  inputForms.forEach((inputForm, index) => {
    const inputs = Array.from(inputForm.getElementsByClassName('product-form__radio'));
    const labels = Array.from(inputForm.getElementsByClassName('product-form__label'));
    const formLabel = inputForm.getElementsByClassName('form__label')[0].children[0];
    labels.forEach((label) => {
      const isMetafield = document.getElementById(`metafield-checkbox-${label.dataset.index}`).getAttribute('is-metafield');
      if (isMetafield != 'true') {
        if (label.getAttribute('for').includes('Color')) {
          hideSoldoutColor(label.dataset.variantId, product, label);
        }
      }

      label.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const dataset = label.dataset;
        var currentVariant = product.variants.find((variant) => variant.id === parseInt(dataset.variantId));
        var parentProduct;
        var finalProduct = product;
        if (!currentVariant) {
          var parentProduct = products.find((product) => product.id === parseInt(dataset.productId));
          currentVariant = parentProduct.variants.find((variant) => variant.id === parseInt(dataset.variantId));
          finalProduct = parentProduct;
        }
        const inputToEdit = document.getElementById(`item-${comboItemIndex + 1}`);
        inputToEdit.value = currentVariant.id;
        formLabel.innerHTML = currentVariant.options[index];
        changeImage(image, currentVariant);
        const clickedInputForm = getClickedInputForm(e.target, inputForms);

        rebuildInputs(currentVariant, inputForms, clickedInputForm, finalProduct);
        // calculateBundlePrice();
        checkIfAllVariantsAvailable();
      });
    });
    inputs.forEach((input) => {
      input.checked = true;
      if (parseInt(input.dataset.variantId) === currentVariant.id) {
        input.checked = true;
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  try {
    const discount = bundleTags.find((tag) => tag.includes('combo_discount'));
    const discountValue = parseInt(discount.split('_')[2]);
    const discountInputElements = document.getElementsByClassName('combo-discount-input');
    Array.from(discountInputElements).forEach((discountInputElement) => {
      discountInputElement.value = discountValue;
    });
    checkIfAllVariantsAvailable();
    // calculateBundlePrice();
    const comboItems = document.getElementsByClassName('combo-single-product');
    Array.from(comboItems).forEach((item, comboItemIndex) => {
      const dataset = item.dataset;
      let compare_id = parseInt(dataset.product_id);
      if (compare_id != parseInt(dataset.parentProduct_id)) {
        compare_id = parseInt(dataset.parentProduct_id);
      }
      const product = products.find((product) => product.id === parseInt(dataset.product_id));
      const currentVariant = product.variants.find((variant) => variant.id === parseInt(dataset.variant_id));
      const image = item.children[0]; // image
      changeImage(image, currentVariant);
      checkInputs(item, currentVariant, product, image, comboItemIndex);
    });
  } catch (e) {
    console.log('combo error', e);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  let variantColors;

  const getVariantColors = () => {
    const swatches = document.getElementsByClassName('color-span');
    const swatchesArray = Array.from(swatches);

    swatchesArray.forEach((swatch) => {
      const colorName = swatch.getAttribute('data-color');
      const color = variantColors[colorName] || variantColors[colorName.toLowerCase()];
      swatch.setAttribute('style', `background-color: ${color}`);
    });
  };
  const getMetaObjects = async () => {
    const response = await fetch('https://nikinclothing.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '1b1977caadc193b7f5f70333d7177f03',
      },
      body: JSON.stringify({
        query: '{\n  metaobjects(type: "variant_color", first:200) {edges {node {fields {key value}}}}}',
      }),
    });
    if (response.ok) {
      const graphql = await response.json();
      const metaobjects = graphql.data.metaobjects.edges.reduce((acc, edge) => {
        acc[edge.node.fields[1].value] = edge.node.fields[0].value;
        return acc;
      }, {});
      variantColors = metaobjects;
      getVariantColors();
    }
  };
  getMetaObjects();


});

function displaySizeOptions(elementId,index){
  let hideOptions = document.querySelectorAll(`.size-elem-${index}`);
  let showOptions = document.querySelectorAll(`.size-elem-${index}[parent-product="related-to-${elementId}"]`);
  let uncheckInputs = document.querySelectorAll(`input[checked='true'].size-elem-${index}`);
  let sizeValue;
  if (uncheckInputs) {
    uncheckInputs.forEach((input)=>{
      input.removeAttribute('checked');
      sizeValue = input.getAttribute('value');
    });
  }
  let checkInputs = document.querySelectorAll(`input.size-elem-${index}[parent-product="related-to-${elementId}"][value="${sizeValue}"]`);
  if (checkInputs) {
    checkInputs.forEach((input)=>{
      setTimeout(() => {
        input.nextElementSibling.click();
      }, 0);
    });
  } else {
    document.querySelector(`input.size-elem-${index}[parent-product="related-to-${elementId}"]`).nextElementSibling.click();
  }
  if (hideOptions) {
    hideOptions.forEach((option)=>{
      option.classList.add('ec-hidden')
    });
  }
  if (showOptions) {
    showOptions.forEach((option)=>{
      option.classList.remove('ec-hidden')
    });
  }
}